var React = require('react') // Installed as a peer dependency of '@haiku/core'
var ReactDOM = require('react-dom') // Installed as a peer dependency of '@haiku/core'
var HaikuReactAdapter = require('@haiku/core/dom/react')
var HaikuReactComponent = HaikuReactAdapter(require('./dom'))
if (HaikuReactComponent.default) HaikuReactComponent = HaikuReactComponent.default
module.exports = HaikuReactComponent


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon1/code/main/react-dom.js
// module id = 429
// module chunks = 35783957827783